module.exports = __webpack_public_path__ + "318ea1ada4102c0704a0637228dcad03.woff";